/* eslint-disable jsx-a11y/href-no-hash */
import React, { Component } from 'react';
import { Button, Table, Dropdown, Input } from 'semantic-ui-react';
import shortid from 'short-id';
import map from 'lodash/map';
import find from 'lodash/find';
import sortBy from 'lodash/sortBy';
import orderBy from 'lodash/orderBy';

import './CanvasList.css';
import { getPages } from '../../fbApi/Page';
import { makePost } from '../../services/ServiceManager';

class CanvasList extends Component {
  state = {
    pages: [],
    selectedPage: '',
    selectedToken: '',
    showConfirm: false,
    filteredCanvases: [],
    searchText: ''
  };

  componentDidMount() {
    this.getPages();
  }

  getPages = async () => {
    const { getFbToken, user } = this.props;
    const token = getFbToken();
    const pages = await getPages(token, user.groups[0]);
    const filteredPages = pages[0].data.concat(pages[1].data).filter((page) => {
      return page.access_token;
    });

    const pagesOptions = sortBy(
      map(filteredPages, (page, index) => ({
        key: index,
        value: { pageId: page.id, access_token: page.access_token },
        text: page.name
      })),
      'text'
    );

    this.setState({ pages: pagesOptions });
  };

  openDialog = (e, { data }) => {
    this.setState({ showConfirm: true, deleteRowId: data.id });
  };

  handleCancel = () => {
    this.setState({ showConfirm: false });
  };

  launchCanvas = (e, { data }) => {
    const parameters = {
      canvasId: data.id,
      pageId: this.state.selectedPage,
      token: this.state.selectedToken
    };

    this.props.launchCanvas(parameters);
  };

  selectPage = (event, data) => {
    const selectedPage = find(data.options, (opt) => {
      return opt.value === data.value;
    });

    this.setState({
      selectedPage: selectedPage.value.pageId,
      selectedToken: selectedPage.value.access_token
    });
  };

  editCanvas = (e, { data }) => {
    this.props.editCanvas(data.id);
  };

  duplicateCanvas = async (e, { data }) => {
    const { user } = this.props;
    const email = user;
    const duplicateJSON = {
      id: data.id,
      email: email.email
    };
    const operation = '/canvasduplicate';
    try {
      // eslint-disable-next-line no-unused-vars
      const resultJson = await makePost(operation, duplicateJSON);
      this.props.refresh();
    } catch (err) {
      console.log('error in duplication', err);
    }
  };

  // eslint-disable-next-line no-unused-vars
  deleteCanvas = (e, { data }) => {
    this.props.deleteCanvas(this.state.deleteRowId);
  };

  getCanvasUrls = (canvas) => {
    const variables = [];
    let headline = canvas.headline;
    let copy = canvas.copy;

    while (headline.indexOf('<') !== -1 && headline.indexOf('>') !== -1) {
      const variable = headline.substring(
        headline.indexOf('<'),
        headline.indexOf('>') + 1
      );
      variables.push(variable);
      headline = headline.replace(variable, '');
    }

    while (copy.indexOf('<') !== -1 && copy.indexOf('>') !== -1) {
      const variable = copy.substring(copy.indexOf('<'), copy.indexOf('>') + 1);
      variables.push(variable);
      copy = copy.replace(variable, '');
    }

    const photos = this.props.canvases.canvasPhoto.list.filter((photo) => {
      return photo.canvasId === canvas.id;
    });
    const carousels = this.props.canvases.canvasCarousel.list.filter(
      (carousel) => {
        return carousel.canvasId === canvas.id;
      }
    );
    return (
      <ul className="urls-list">
        {variables.map((variable) =>
          variable ? <li key={shortid.generate()}>{variable}</li> : null
        )}
        {photos.map((photo) =>
          photo.targetUrl ? (
            <li key={shortid.generate()}>{photo.targetUrl}</li>
          ) : null
        )}
        {carousels.map((carousel) =>
          this.props.canvases.canvasCarouselCard.list.map((item) =>
            item.targetUrl && carousel.id === item.carouselId ? (
              <li key={shortid.generate()}>{item.targetUrl}</li>
            ) : null
          )
        )}
      </ul>
    );
  };

  searchCanvas = (event, { value }) => {
    this.setState({ searchText: value });
  };

  filteredCanvas = () => {
    const { searchText } = this.state;
    const { canvases: graphQLCanvasData, user } = this.props;
    const { list: canvasList } = graphQLCanvasData.canvases;
    let canvases = canvasList;

    // This leaves room for possibility for future guests
    const applyGuestFilter = ['NU'].includes(user.groups[0]);

    if (applyGuestFilter) {
      canvases = canvasList.filter((canvas) => canvas.createdBy === user.email);
    }

    if (searchText) {
      return canvases.filter(
        (canvas) =>
          canvas.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
      );
    }

    return canvases;
  };

  render() {
    if (this.props.canvases) {
      return (
        <div>
          <Dropdown
            placeholder="Client Page Name"
            search
            selection
            options={this.state.pages}
            onChange={this.selectPage}
          />
          <Input
            className="canvas-search"
            placeholder="Search"
            type="text"
            name="search"
            onChange={this.searchCanvas}
          />
          <div className="new-canvas-link">
            <a href="#" onClick={this.props.newCanvas}>
              NEW CANVAS +
            </a>
          </div>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell className="row-name">Name</Table.HeaderCell>
                <Table.HeaderCell className="row-by">
                  Created By
                </Table.HeaderCell>
                <Table.HeaderCell className="row-date">
                  Created At
                </Table.HeaderCell>
                <Table.HeaderCell className="row-by">
                  Updated By
                </Table.HeaderCell>
                <Table.HeaderCell className="row-date">
                  Updated At
                </Table.HeaderCell>
                <Table.HeaderCell className="row-operations">
                  Operations
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body style={{ 'word-break': 'break-all' }}>
              {orderBy(this.filteredCanvas(), 'createdAt')
                .reverse()
                .map((canvas) => (
                  <Table.Row key={canvas.id}>
                    <Table.Cell>{canvas.name}</Table.Cell>
                    <Table.Cell>{canvas.createdBy}</Table.Cell>
                    <Table.Cell>
                      {new Date(Date.parse(canvas.createdAt)).toLocaleString(
                        'en-us',
                        {
                          month: 'long',
                          day: '2-digit',
                          year: 'numeric',
                          hour: 'numeric',
                          minute: 'numeric'
                        }
                      )}
                    </Table.Cell>
                    <Table.Cell>{canvas.updatedBy}</Table.Cell>
                    <Table.Cell>
                      {new Date(Date.parse(canvas.updatedAt)).toLocaleString(
                        'en-us',
                        {
                          month: 'long',
                          day: '2-digit',
                          year: 'numeric',
                          hour: 'numeric',
                          minute: 'numeric'
                        }
                      )}
                    </Table.Cell>
                    <Table.Cell className="column-operations">
                      {!this.state.showConfirm ||
                      canvas.id !== this.state.deleteRowId ? (
                        <Button
                          data={{ id: canvas.id }}
                          onClick={this.duplicateCanvas}
                          size="small"
                          color="blue"
                          className="button-edit operation-button"
                        >
                          Duplicate
                        </Button>
                      ) : null}
                      {!this.state.showConfirm ||
                      canvas.id !== this.state.deleteRowId ? (
                        <Button
                          data={{ id: canvas.id }}
                          onClick={this.editCanvas}
                          size="small"
                          color="blue"
                          className="button-edit edit-delete-buttons"
                        >
                          Edit
                        </Button>
                      ) : null}
                      {this.state.showConfirm &&
                      canvas.id === this.state.deleteRowId ? (
                        <div className="div-confirm">
                          <p className="text-confirm">Are you sure?</p>
                          <Button
                            onClick={this.deleteCanvas}
                            size="mini"
                            color="grey"
                          >
                            Yes
                          </Button>
                          <Button
                            onClick={this.handleCancel}
                            size="mini"
                            color="red"
                          >
                            No
                          </Button>
                        </div>
                      ) : (
                        <Button
                          data={{ id: canvas.id }}
                          onClick={this.openDialog}
                          size="small"
                          color="blue"
                          className="button-edit edit-delete-buttons"
                        >
                          Delete
                        </Button>
                      )}
                      {!this.state.showConfirm ||
                      canvas.id !== this.state.deleteRowId ? (
                        <Button
                          data={{ id: canvas.id }}
                          onClick={this.launchCanvas}
                          disabled={this.state.nextTab > 10}
                          size="small"
                          color="blue"
                          className="operation-button"
                        >
                          Launch
                        </Button>
                      ) : null}
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </div>
      );
    }
    return null;
  }
}

export default CanvasList;



// WEBPACK FOOTER //
// ./src/screens/Canvas/CanvasList.js